<template>
  <v-container fill-height class="justify-center">
    <v-row justify="center">
      <v-col cols="10" md="6" lg="4" xl="3">
        <v-card
          class="pa-8"
          height="100%"
          width="100%"
          flat
          :disabled="disableCard"
          :elevation="3"
          @click="handleCaptcha()"
        >
          <v-row class="mb-2" justify="center">
            <v-col cols="8">
              <v-img :src="require('@/assets/new_figure.png')" />
            </v-col>
          </v-row>

          <div class="text-h6 font-weight-light text-center">
            Iniciar Novo Atendimento
          </div>
        </v-card>
      </v-col>

      <!-- <v-col cols="7" md="6" lg="4" xl="3">
        <v-card
          class="pa-8"
          height="100%"
          :disabled="disableCard"
          :elevation="3"
          flat
          @click="handleSelectUnity()"
        >
          <v-row class="mb-2" justify="center">
            <v-col cols="10">
              <v-img :src="require('@/assets/queue_figure.png')" />
            </v-col>
          </v-row>

          <div class="text-h6 font-weight-light text-center">Audiências</div>

          <div class="text-body-1 font-weight-light text-center mt-n1">
            Entrar no corredor de espera
          </div>
        </v-card>
      </v-col> -->
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="8" xl="7">
        <div class="mb-12 text-body-1 primary--text text-center">
          <p class="black--text font-weight-light text-decoration-underline">
            O horário de Atendimento do Balcão Virtual
          </p>

          <p>
            - Zonas Eleitorais (1º Grau) o atendimento é realizado nos
            <span class="font-weight-bold"> dias úteis das 11h às 17h </span
            ><br />
            - Na Secretaria Judiciária (2º Grau) o atendimento será realizado
            nos
            <span class="font-weight-bold">
              dias úteis, sábados, domingos e feriados das 12h às 19h
            </span>
            devido ao período eleitoral a partir de 15 de agosto de 2026.
          </p>

          <p class="black--text font-weight-light">
            <i>
              Exceções: favor consultar o site do TRE-SP em Serviços Judiciais -
              Balcão Virtual,
              <a
                href="https://www.tre-sp.jus.br/servicos-judiciais/novo_balcao-virtual"
                target="_blank"
                class="font-weight-bold"
                >clicando aqui!</a
              >
            </i>
          </p>
        </div>

        <div class="text-body-1 font-weight-light text-center">
          Use a opção acima para iniciar um novo atendimento. Este canal foi
          criado para facilitar o contato direto entre cidadãos, advogados(as) e
          a Justiça Eleitoral do Estado de São Paulo.
        </div>
      </v-col>
    </v-row>

    <!-- O Overlay de loading -->
    <LoadingOverlay :loading="loading.overlay" />

    <v-dialog v-model="unityDialog" max-width="25rem" persistent>
      <v-card class="pa-6 rounded-lg">
        <div class="d-flex align-center mb-4">
          <div class="text-body-1 font-weight-bold">Selecione uma unidade</div>

          <v-spacer />

          <v-btn icon @click="cancelUnity()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-form v-model="valid.unity" ref="formUnity" autocomplete="off">
          <v-select
            v-model="form.unity"
            :items="unities"
            placeholder="Selecione uma unidade"
            item-value="name"
            item-text="name"
            :rules="_rules"
            outlined
          ></v-select>
        </v-form>

        <v-btn
          class="text-none"
          color="primary"
          @click="submitUnity()"
          block
          large
        >
          Confirmar
        </v-btn>
      </v-card>
    </v-dialog>

    <!-- Dialog de Captcha -->
    <v-dialog v-model="captchaDialog" max-width="19.75rem" persistent>
      <v-card v-if="captchaDialog" class="pa-2">
        <vue-recaptcha
          ref="recaptcha"
          :sitekey="_siteKey"
          @verify="onVerify"
          @expired="onExpired"
        ></vue-recaptcha>
      </v-card>
    </v-dialog>

    <SelectorDialog
      v-model="selectorDialog"
      :loading="loading.general"
      @submit="dialogSubmit"
      @cancel="handlerCancelSession()"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { updateAttendance } from "@/services/attendance.js";
import { handleAlert, formatDocument, showError } from "@/utils";
import { getCourts } from "@/services/courts";
import { VueRecaptcha } from "vue-recaptcha";
import LoadingOverlay from "@/components/loadingOverlay/LoadingOverlay.vue";
import SelectorDialog from "./partials/selectorDialog/SelectorDialog.vue";

export default {
  name: "Home",

  components: {
    LoadingOverlay,
    VueRecaptcha,
    SelectorDialog,
  },

  data() {
    return {
      selectorDialog: false,
      loading: {
        general: false,
        overlay: false,
        unities: false,
      },
      disableCard: false,
      validCaptcha: false,
      unityDialog: false,
      unities: [],
      valid: {
        unity: false,
      },
      form: {
        unity: "",
      },
      showForm: false,
      dialog: false,
      captchaDialog: false,
      dialogTitle: "Escolha abaixo a instância e o balcão de atendimento",
      person: {
        _id: "65e8d608f975c49e4a156051",
        name: "Solicitante",
        cpf: "000.000.000-00",
        email: "solicitante@tre-sp.jus.br",
        phone: "11999999999",
      },
    };
  },

  computed: {
    ...mapState("socket", ["attendance"]),

    _siteKey() {
      return process.env.VUE_APP_GCAPTCHA_PUBLIC_KEY;
    },

    _rules() {
      return [(v) => !!v || "Campo obrigatório"];
    },
  },

  mounted() {
    this.handleQuerys();
  },

  methods: {
    ...mapActions("socket", [
      "createNewAttendance",
      "requestAttendance",
      "cancelAttendance",
      "setAttendance",
      "setMessages",
    ]),
    ...mapActions(["setPreSelection"]),

    handleCaptcha() {
      this.captchaDialog = true;
    },

    handleSelectUnity() {
      this.getCourts();
      this.unityDialog = true;
    },

    submitUnity() {
      if (!this.$refs.formUnity.validate()) return;

      const unity = this.form.unity
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      const newName = unity
        .toLowerCase()
        .replace(/[^\w\s]/g, "")
        .replace(/\s+/g, "-");

      window.location.href = `https://audiencias-app-673194685875.us-central1.run.app/${newName}/entrar`;
    },

    cancelUnity() {
      this.unityDialog = false;
      this.form.unity = "";
    },

    async getCourts() {
      try {
        this.loading.unities = true;

        const payload = {
          limit: 100,
          offset: 0,
          enableAudience: true,
        };

        const { data } = await getCourts(payload);
        this.unities = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading.unities = false;
      }
    },

    onVerify(response) {
      if (!response) return (this.captchaDialog = false);
      this.validCaptcha = true;
      this.captchaDialog = false;
      this.handlerOpenModal();
    },

    onExpired() {
      this.validCaptcha = false;
      this.captchaDialog = false;
    },

    async handleQuerys() {
      const query = this.$route.query;

      if (!query || !Object.keys(query).length) return;

      this.loading.overlay = true;

      const payload = {
        ...(query.deskID && { deskID: query.deskID }),
        ...(query.subgroupID && { subgroupID: query.subgroupID }),
        ...(query.groupID && { groupID: query.groupID }),
      };

      await this.setPreSelection(payload);
      if (Object.keys(payload).length) await this.handlerOpenModal();

      this.loading.overlay = false;
    },

    async handlerOpenModal() {
      this.blockCard();

      this.loading.general = true;

      try {
        this.createNewAttendance({
          callback: (error, data) => {
            console.log("createNewAttendance:data", data);

            if (error) {
              console.log("createNewAttendance:error", error);
              throw new Error("Falha ao tentar conectar ao socket. error");
            }

            this.setAttendance(data);
            this.selectorDialog = true;
          },
        });
      } catch (error) {
        this.showError(error);
      } finally {
        this.loading.general = false;
      }
    },
    async handlerStartSession(event) {
      if (this.loading.general) {
        return;
      }

      this.loading.general = true;

      try {
        const desk = event.desks;
        const group = event.groups;

        if (!desk || !group) {
          throw new Error("Selecione onde você deseja ser atendido!");
        }

        const payload = {
          requester: {
            name: this.person.name,
            email: this.person.email,
            cpf: this.person.cpf,
            phone: this.person.phone,
          },
          deskID: desk._id,
          comarcaID: group._id,
          varaID: desk.vara._id,
          attendanceFormat: "video",
        };

        // Update Attendance on API
        await updateAttendance(this.attendance._id, payload);

        // Send Emit to Request attendance on Socket Server
        await this.requestAttendance({
          data: { protocol: this.attendance.protocol, deskID: desk._id },
          callback: (error, data) => {
            console.log("requestAttendance:data", data);

            if (error) {
              console.log("requestAttendance:error", error);
              throw new Error(
                "Falha ao tentar solicitar atendimento. Tente novamente"
              );
            }

            // Update Attendance on Store
            this.setAttendance(data);

            // Redirecting to Queue...
            this.$router.push({ path: "/queue" });
          },
        });
      } catch (error) {
        this.showError(error);
      } finally {
        this.loading.general = false;
      }
    },
    async handlerCancelSession() {
      this.loading.general = true;

      try {
        if (!this.attendance?._id) {
          throw new Error("Atendimento não encontrado.");
        }

        // Send Emit to Cancel attendance on Socket Server
        await this.cancelAttendance({
          data: { attendanceID: this.attendance._id },
          callback: (error, data) => {
            console.log("cancelAttendance:data", data);

            if (error) {
              console.log("cancelAttendance:error", error);
              throw new Error(
                "Falha ao tentar cancelar atendimento. Tente novamente."
              );
            }

            this.handleAlert("Atendimento cancelado!", "warning");
            this.selectorDialog = false;
          },
        });
      } catch (error) {
        this.showError(error);
      } finally {
        this.loading.general = false;
        this.setAttendance(null);
      }
    },

    blockCard() {
      this.disableCard = true;

      setTimeout(() => {
        this.disableCard = false;
      }, 1000);
    },

    async dialogSubmit(event) {
      this.handlerStartSession(event);
    },

    showError,

    handleAlert,

    formatDocument,
  },
};
</script>

<style src="./style.scss" lang="scss" />
